import { Link } from "react-router-dom";
import SEO from "./SEO";

export default function NotFound() {
  return (
    <main style={{ padding: 40 }}>
      <SEO title="Page not found | AT Appliance Repair" noindex />
      <h1>Page not found</h1>
      <p><Link to="/serviceareas">See the areas we serve</Link> or call <a href="tel:+13316004935">(331) 600-4935</a>.</p>
    </main>
  );
}